import React from 'react';
import { COVERME_ROUTES, SUPPORTED_LOCALES } from '@trip-ux/constants';
import { lazyWithChunkRetry } from '@trip-ux/common';

const TravellerDetails = lazyWithChunkRetry(() => import('./traveller-details/TravellerDetails'));
const TripDetails = lazyWithChunkRetry(() => import('./trip-details/TripDetails'));
const SelectPlan = lazyWithChunkRetry(() => import('./select-plan/SelectPlan'));
const QuoteDetails = lazyWithChunkRetry(() => import('./quote-details/QuoteDetails'));
const ContactDetails = lazyWithChunkRetry(() => import('./contact-details/ContactDetails'));
const Payment = lazyWithChunkRetry(() => import('./payment/Payment'));
const Confirmation = lazyWithChunkRetry(() => import('./confirmation/Confirmation'));

export type CovermeRouteEntry = {
  absolutePaths: string[];
  relativePaths: string[]; // Pre-computed relative paths for admin routing
  element: JSX.Element;
};

// Helper function to extract relative path from absolute path
// This runs once at configuration time instead of every render
const getRelativePath = (absolutePath: string): string => {
  return absolutePath.split('/').pop() || '';
};

export const getCovermeRouteEntries = (): CovermeRouteEntry[] => {
  const enRoutes = COVERME_ROUTES[SUPPORTED_LOCALES.ENGLISH];
  const frRoutes = COVERME_ROUTES[SUPPORTED_LOCALES.FRENCH];

  return [
    { 
      absolutePaths: [enRoutes.TRAVELLER_DETAILS, frRoutes.TRAVELLER_DETAILS], 
      relativePaths: [getRelativePath(enRoutes.TRAVELLER_DETAILS), getRelativePath(frRoutes.TRAVELLER_DETAILS)],
      element: <TravellerDetails /> 
    },
    { 
      absolutePaths: [enRoutes.TRIP_DETAILS, frRoutes.TRIP_DETAILS], 
      relativePaths: [getRelativePath(enRoutes.TRIP_DETAILS), getRelativePath(frRoutes.TRIP_DETAILS)],
      element: <TripDetails /> 
    },
    { 
      absolutePaths: [enRoutes.SELECT_PLAN, frRoutes.SELECT_PLAN], 
      relativePaths: [getRelativePath(enRoutes.SELECT_PLAN), getRelativePath(frRoutes.SELECT_PLAN)],
      element: <SelectPlan /> 
    },
    { 
      absolutePaths: [enRoutes.QUOTE_DETAILS, frRoutes.QUOTE_DETAILS], 
      relativePaths: [getRelativePath(enRoutes.QUOTE_DETAILS), getRelativePath(frRoutes.QUOTE_DETAILS)],
      element: <QuoteDetails /> 
    },
    { 
      absolutePaths: [enRoutes.CONTACT_DETAILS, frRoutes.CONTACT_DETAILS], 
      relativePaths: [getRelativePath(enRoutes.CONTACT_DETAILS), getRelativePath(frRoutes.CONTACT_DETAILS)],
      element: <ContactDetails /> 
    },
    { 
      absolutePaths: [enRoutes.PAYMENT, frRoutes.PAYMENT], 
      relativePaths: [getRelativePath(enRoutes.PAYMENT), getRelativePath(frRoutes.PAYMENT)],
      element: <Payment /> 
    },
    { 
      absolutePaths: [enRoutes.CONFIRMATION, frRoutes.CONFIRMATION], 
      relativePaths: [getRelativePath(enRoutes.CONFIRMATION), getRelativePath(frRoutes.CONFIRMATION)],
      element: <Confirmation /> 
    }
  ];
};

export default getCovermeRouteEntries;
